/**
 * riskactions.js
 * Created by calhosh on 11/6/2019.
 */

import * as types from '../actiontypes';
import {serviceURL} from '../../util/uiconstants';
import env from '../../util/env';
import {API_RESOURCES, createApiReadAction, createApiCreateAction, createApiDeleteAction} from '../../util/api';

export const getRisksForWcgwId = (url) => {
	return {
		type: types.GET_RISKS_FOR_WCGWID,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const getRelatedRiskForWCGWId = (url) => {
	return {
		type: types.GET_RELATED_RISKS_FOR_WCGWID,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

// Deprecated. Use getRisks function instead.
export const getRisks_old = (url) => {
	return {
		type: types.GET_RISKS,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const getRisks = (engagementId, queryParameters, actionArgs, trackWithArea, resolve = false) => {
	return createApiReadAction(
		types.GET_RISKS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.RISKS]: undefined
		},
		queryParameters,
		{
			...actionArgs,
			resolve: true
		},
		undefined,
		trackWithArea,
		resolve
	);
};

export const getRisksToRelate = (engagementId, queryParameters, actionArgs) => {
	return createApiReadAction(
		types.GET_RISKS_TO_RELATE,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.RISKS]: undefined
		},
		queryParameters,
		actionArgs
	);
};

export const getRiskById = (engagementId, riskId, queryParameters, actionArgs, trackWithArea) => {
	return createApiReadAction(
		types.GET_RISK_BY_ID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.RISKS]: riskId
		},
		queryParameters,
		{
			...actionArgs,
			riskId,
			resolve: true
		},
		undefined,
		trackWithArea
	);
};

export const relateSCOTToRisk = (engagementId, riskId, data) => {
	return createApiCreateAction(
		types.RELATE_SCOT_TO_RISK,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.RISKS]: riskId,
			[API_RESOURCES.SCOTS]: null
		},
		data
	);
};

export const unRelateSCOTToRisk = (engagementId, riskId, scotId) => {
	return createApiDeleteAction(types.UNRELATE_SCOT_TO_RISK, {
		[API_RESOURCES.ENGAGEMENTS]: engagementId,
		[API_RESOURCES.RISKS]: riskId,
		[API_RESOURCES.SCOT]: scotId
	});
};

export function updateStoreRelateScotToRisk(data) {
	return {
		type: types.UPDATE_STORE_RELATE_SCOT_TO_RISK,
		payload: data
	};
}

export function updateStoreUnRelateScotToRisk(data) {
	return {
		type: types.UPDATE_STORE_UNRELATE_SCOT_TO_RISK,
		payload: data
	};
}

export const clearRisk = (actionArgs) => {
	return {
		type: types.CLEAR_RISK,
		...actionArgs
	};
};

export const getAssertionsForRiskId = (url) => {
	return {
		type: types.GET_ASSERTIONS_FOR_RISKID,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const updateCheckedForScotWcgw = (scots, scotId, wcgwId, checked) => {
	if (scots) {
		let found = scots[0].scots.find((scot) => {
			return scot.scotId === scotId;
		});
		if (found) {
			found = found.wcgws.find((wcgw) => {
				return wcgw.wcgwId === wcgwId;
			});
			if (found) {
				found.selected = checked;
			}
		}
	}
	return {
		type: types.GET_SCOTS_FOR_ASSERTIONID,
		response: scots
	};
};

export const updateRisk = (engagementId, risk, actionProps) => {
	const url = env.getBaseURL(serviceURL, Number(engagementId)) + 'Risks' + '/' + risk.id;
	return {
		type: types.UPDATE_RISK,
		...actionProps,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: risk
			}
		},
		risk
	};
};

export const createNewRisk = (engagementId, data, actionProps) => {
	const url = env.getBaseURL(serviceURL, Number(engagementId)) + 'Risks';
	return {
		type: types.CREATE_RISK,
		resolve: true,
		...actionProps,
		meta: {
			api: {
				url,
				method: 'POST',
				data: data
			}
		}
	};
};

export const clearNewRisk = () => {
	return {
		type: types.CLEAR_NEW_RISK
	};
};

export const IsDisplayEstimateTypeMismatchClientSideValidationMessage = (isDisplayEstimateTypeMismatchClientSideValidationMessage) => {
	return {
		type: types.DISPLAY_ESTIMATETYPE_MISMATCH_CLIENT_VALIDATION_MESSAGE,
		isDisplayEstimateTypeMismatchClientSideValidationMessage: isDisplayEstimateTypeMismatchClientSideValidationMessage
	};
};

export const manageRisks = (url, data) => {
	return {
		type: types.MANAGE_RISK,
		meta: {
			api: {
				url,
				method: 'PATCH',
				data: data
			}
		}
	};
};

export const createAssertionRiskRelation = (
	engagementId,
	risk,
	assertionModel,
	reducerModel,
	hash,
	assertions = null,
	resolve = false
) => {
	const url = env.getBaseURL(serviceURL, Number(engagementId)) + 'Risks' + '/' + risk.id + '/Assertions';
	return {
		type: types.CREATE_ASSERTION_RISK_RELATION,
		resolve,
		meta: {
			api: {
				url,
				method: 'POST',
				data: assertionModel
			}
		},
		reducerModel,
		risk,
		hash,
		assertions
	};
};

export const updateAssertionRiskRelation = (engagementId, riskId, assertions) => {
	const url = env.getBaseURL(serviceURL, Number(engagementId)) + 'Risks' + '/' + riskId + '/Assertions';
	return {
		type: types.UPDATE_ASSERTION_RISK_RELATION,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: assertions
			}
		}
	};
};

export const deleteAssertionRiskRelation = (engagementId, risk, assertionIds, hash) => {
	const url = env.getBaseURL(serviceURL, Number(engagementId)) + 'Risks' + '/' + risk.id + '/Assertions';

	return {
		type: types.DELETE_ASSERTION_RISK_RELATION,
		meta: {
			api: {
				url,
				method: 'DELETE',
				data: assertionIds
			}
		},
		risk,
		assertionIds,
		hash
	};
};

export const createRiskFormBodyOption = (sectionId, bodyId, engagementId, risk, formBodyOptionId, data) => {
	return createApiCreateAction(
		types.CREATE_RISK_FORMBODYOPTION,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.RISKS]: risk.id,
			[API_RESOURCES.FORMBODYOPTION]: undefined
		},
		data,
		{
			sectionId,
			bodyId,
			risk,
			formBodyOptionId
		}
	);
};

export const deleteRiskFormBodyOption = (sectionId, bodyId, engagementId, riskId, formBodyOptionId) => {
	return createApiDeleteAction(
		types.DELETE_RISK_FORMBODYOPTION,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.RISKS]: riskId,
			[API_RESOURCES.FORMBODYOPTION]: formBodyOptionId
		},
		{
			sectionId,
			bodyId,
			riskId,
			formBodyOptionId
		}
	);
};

export const findRiskFromFormData = (state, bodyId, formBodyOptionId, riskId, formSectionId) => {
	let risk;

	let section = formSectionId ? state.find((x) => x.sectionId === formSectionId) : state[0];

	if (section?.bodies?.length > 0) {
		let rf = section.bodies.find((b) => b.id === bodyId);
		if (rf && rf.optionsAndResponses) {
			let rfOptions = rf.optionsAndResponses.find((o) => o.bodyOptionId === formBodyOptionId);
			if (rfOptions && rfOptions.riskList) {
				risk = rfOptions.riskList;
			}
		}
	}

	return risk;
};

export const deleteRisk = (engagementId, riskId, actionProps) => {
	const url = env.getBaseURL(serviceURL, Number(engagementId)) + 'Risks' + '/' + riskId;

	return {
		type: types.DELETE_RISK,
		...actionProps,
		meta: {
			api: {
				url,
				method: 'DELETE',
				data: riskId
			}
		},
		riskId
	};
};

export const relateEstimateToRisk = (engagementId, riskId, data) => {
	return createApiCreateAction(
		types.RELATE_ESTIMATE_TO_RISK,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.RISKS]: riskId,
			[API_RESOURCES.PARENT_RISKS]: null
		},
		data
	);
};

export const unRelateEstimateToRisk = (engagementId, riskId, parentRiskId) => {
	return createApiDeleteAction(types.UNRELATE_ESTIMATE_TO_RISK, {
		[API_RESOURCES.ENGAGEMENTS]: engagementId,
		[API_RESOURCES.RISKS]: riskId,
		[API_RESOURCES.PARENT_RISKS]: parentRiskId
	});
};

export function updateStoreUnRelateAccountToRisk(data) {
	return {
		type: types.UPDATE_STORE_UNRELATE_ACCOUNT_TO_RISK,
		payload: data
	};
}
